module.exports = __webpack_public_path__ + "static/rick and morty-book-one-3ed5b93704742e7bf0abc1ca5f956340.jpg";